<h1 mat-dialog-title>Listado de usuarios connectados</h1>
<div mat-dialog-content>
    <div fxLayout="row wrap">
        <div class="p-10" fxFlex="100">
            <mat-form-field>
                <input matInput (keyup)="onApplyFilter($event.target.value)" placeholder="Filtro" />
            </mat-form-field>
            <div class="table-container">
                <mat-progress-bar mode="indeterminate" *ngIf="isLoadingResults"></mat-progress-bar>
                <div class="loading-shade" *ngIf="isLoadingResults"></div>
                <div class="table-content responsive-table">
                    <mat-table [dataSource]="dataSource" matSort>
                        <!-- Code Column -->
                        <ng-container matColumnDef="userName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Raqueta </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{ row.userName }} </mat-cell>
                        </ng-container>

                        <!-- Sex Column -->
                        <ng-container matColumnDef="displayName">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </mat-header-cell>
                            <mat-cell *matCellDef="let row"> {{ row.displayName }} </mat-cell>
                        </ng-container>

                        <!-- Quantity Column -->
                        <ng-container matColumnDef="timestamp">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Ultima señal </mat-header-cell>
                            <mat-cell *matCellDef="let row">
                                {{ row.timestamp | fbDate : 'dd/MM/yyyy HH:mm:ss' }}
                            </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns"> </mat-row>
                    </mat-table>

                    <mat-paginator [pageSizeOptions]="[50, 100, 200]"></mat-paginator>
                </div>
            </div>
        </div>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="primary" (click)="onClose()" tabindex="2">Cerrar</button>
</div>
